<template>
    <div
        :class="[
            focus && 'spotlight-input--active',
            'spotlight-input'
        ]"
    >
        <i 
            @click.prevent="picked=''; result=[];"
            :class="[
                picked && 'spotlight-input__icon-close--active',
                'spotlight-input__icon-close icon-close'
            ]"
        ></i>
        <input 
            class="spotlight-input__input" 
            type="text" 
            @focus="focus = true"
            @blur="focus = false" 
            @keydown="debounce"
            v-model="picked"
            placeholder="Suchen..."
        />
        <ul class="spotlight-input__sugestions" >
            <template v-for="item in result">
                <li :key="item.id">
                    <a 
                        class="spotlight-input__link" 
                        @mousedown.prevent 
                        :href="item.url"
                    >
                        <span v-html='item.highlight ? item.highlight : item.title' />
                    </a>
                    <span class="spotlight-input__badge" v-if="item.type">
                        {{ item.type }}
                    </span>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
  props: {
    uri: String,
    result: Array,
  },
  data() {
      return {
          focus: false,
          picked: '',
      }
  },
  methods: {
    debounce: _.debounce(function(){
      this.spotlight();
    }, 300),

    spotlight() {
      fetch(this.uri+'?arg='+this.picked)
      .then(response => response.json())
      .then(data => {
          this.result = data.result
      })
      .catch( error => {
          window.console.log("Error at ToggleAjax: "+error);
      })
    },
  },
};
</script>

<style>
</style>
